import { ActionReducerMap } from '@ngrx/store';
import * as fromAuth from '@qvs/core/auth';
import * as fromApp from '~/modules/app/slice';
import * as fromEnv from '@qvs/core/env';
import * as fromUser from '@qvs/core/user';
import * as fromPreference from '@qvs/core/preference';
import * as fromRemoteConfig from '@qvs/core/remoteConfig';
import * as fromPortfolio from '~/modules/portfolio/slice';
import * as fromCountries from '~/modules/countries/slice';
import * as fromCurrencies from '~/modules/currencies/slice';
import * as fromExchangeRates from '~/modules/exchangeRates/slice';
import * as fromMandateTypes from '~/modules/mandateTypes/slice';
import * as fromAccounts from '~/modules/accounts/slice';
import * as fromEDocuments from '~/modules/e-documents/slice';
import * as fromNews from '~/modules/news/slice';
import * as fromRegistration from '@qvs/core/registration';
import * as fromPayments from '~/modules/payments/slice';
import * as fromInvestmentOrders from '~/modules/investmentOrder/slice';
import * as fromInstruments from '~/modules/instrument/slice';

export interface State {
  [fromApp.appFeatureKey]: fromApp.State;
  [fromAuth.authFeatureKey]: fromAuth.State;
  [fromEnv.envFeatureKey]: fromEnv.State;
  [fromUser.userFeatureKey]: fromUser.State;
  [fromPreference.preferenceFeatureKey]: fromPreference.State;
  [fromRemoteConfig.remoteConfigFeatureKey]: fromRemoteConfig.State;
  [fromPortfolio.portfolioFeatureKey]: fromPortfolio.State;
  [fromMandateTypes.mandateTypesFeatureKey]: fromMandateTypes.State;
  [fromAccounts.accountFeatureKey]: fromAccounts.State;
  [fromCountries.countryFeatureKey]: fromCountries.State;
  [fromCurrencies.currenciesFeatureKey]: fromCurrencies.State;
  [fromExchangeRates.exchangeRatesFeatureKey]: fromExchangeRates.State;
  [fromEDocuments.eDocumentsFeatureKey]: fromEDocuments.State;
  [fromNews.newsFeatureKey]: fromNews.State;
  [fromRegistration.registrationFeatureKey]: fromRegistration.State;
  [fromPayments.paymentsFeatureKey]: fromPayments.State;
  [fromInvestmentOrders.investmentOrderFeatureKey]: fromInvestmentOrders.State;
  [fromInstruments.instrumentFeatureKey]: fromInstruments.State;
}

export const reducers: ActionReducerMap<State> = {
  [fromApp.appFeatureKey]: fromApp.reducer,
  [fromAuth.authFeatureKey]: fromAuth.reducer,
  [fromEnv.envFeatureKey]: fromEnv.reducer,
  [fromUser.userFeatureKey]: fromUser.reducer,
  [fromPreference.preferenceFeatureKey]: fromPreference.preferenceFeature.reducer,
  [fromRemoteConfig.remoteConfigFeatureKey]: fromRemoteConfig.remoteConfigFeature.reducer,
  [fromPortfolio.portfolioFeatureKey]: fromPortfolio.reducer,
  [fromMandateTypes.mandateTypesFeatureKey]: fromMandateTypes.mandateTypesFeature.reducer,
  [fromAccounts.accountFeatureKey]: fromAccounts.accountFeature.reducer,
  [fromCountries.countryFeatureKey]: fromCountries.countryFeature.reducer,
  [fromCurrencies.currenciesFeatureKey]: fromCurrencies.currenciesFeature.reducer,
  [fromExchangeRates.exchangeRatesFeatureKey]: fromExchangeRates.exchangeRatesFeature.reducer,
  [fromEDocuments.eDocumentsFeatureKey]: fromEDocuments.eDocumentsFeature.reducer,
  [fromNews.newsFeatureKey]: fromNews.reducer,
  [fromRegistration.registrationFeatureKey]: fromRegistration.reducer,
  [fromPayments.paymentsFeatureKey]: fromPayments.reducer,
  [fromInvestmentOrders.investmentOrderFeatureKey]: fromInvestmentOrders.investmentOrderFeature.reducer,
  [fromInstruments.instrumentFeatureKey]: fromInstruments.instrumentFeature.reducer
};
